import { Link } from '@inertiajs/react'
import { Box } from '@mantine/core'
import { IconArrowBackUp, IconArrowForwardUp, IconChevronLeft, IconSettings } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { Segmented } from '../v2/Segmented'
import { IconSparklesTwo } from '../icons'
import { cx } from '../../utils/cx'
import css from '../../styles/EditorV2.module.css'

/**
 * The row above the editor cards: Editor | Chat tabs (320×40, 16px labels) on the left and
 * "Generate Ad with AI" / "Settings" on the right (Figma 421:96570 / 492:41526).
 * AD-234: Undo / Redo of the ad's edits, disabled while there is nothing to undo or redo.
 */
export function EditorToolbar({
  homeUrl, tab, onTabChange, chatEnabled, onGenerate, onCampaign, disabled,
  onUndo, onRedo, canUndo = false, canRedo = false,
}) {
  const { t } = useTranslation()
  return (
    <div className={css.toolbar}>
      <Box hiddenFrom="sm" className={css.toolbarTitle}>
        <Link href={homeUrl} className={cx(css.button, css.toolbarIcon)} aria-label={t('editorV2.shell.backToInspiration')}>
          <IconChevronLeft size={16} stroke={1.8} aria-hidden="true" />
        </Link>
        <h1 className={css.toolbarHeading}>{t('editorV2.shell.editAd')}</h1>
      </Box>
      <Segmented
        ariaLabel={t('editorV2.shell.toolbar.mode')}
        size="tabs"
        value={tab}
        onChange={onTabChange}
        className={css.toolbarTabs}
        options={[
          { value: 'editor', label: t('editorV2.shell.toolbar.editor') },
          { value: 'chat', label: t('editorV2.shell.toolbar.chat'), disabled: !chatEnabled, title: chatEnabled ? undefined : t('editorV2.shell.toolbar.chatDisabled') },
        ]}
      />
      <div className={css.toolbarActions}>
        <div className={css.toolbarTools}>
          <div className={css.history}>
            {onUndo && (
              <button type="button" className={css.button} onClick={onUndo} disabled={disabled || !canUndo} title={t('editorV2.shell.toolbar.undoTitle')}>
                <IconArrowBackUp size={16} stroke={1.6} />
                <span className={css.phoneHidden}>{t('editorV2.shell.toolbar.undo')}</span>
              </button>
            )}
            {onRedo && (
              <button type="button" className={css.button} onClick={onRedo} disabled={disabled || !canRedo} title={t('editorV2.shell.toolbar.redoTitle')}>
                <IconArrowForwardUp size={16} stroke={1.6} />
                <span className={css.phoneHidden}>{t('editorV2.shell.toolbar.redo')}</span>
              </button>
            )}
          </div>
          <button type="button" className={cx(css.button, css.toolbarIcon)} onClick={onGenerate} disabled={disabled} aria-label={t('editorV2.shell.toolbar.generate')}>
            <IconSparklesTwo size={16} stroke={1.6} />
            <span className={css.phoneHidden}>{t('editorV2.shell.toolbar.generate')}</span>
          </button>
        </div>
        <button type="button" className={cx(css.button, css.toolbarCampaign)} onClick={onCampaign}>
          <IconSettings size={16} stroke={1.6} />
          {t('editorV2.shell.settings')}
        </button>
      </div>
    </div>
  )
}
